import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { PATCH_URL } from '@utils/api/endpoints';

type Payload = {
  orgId: number | string;
  monthly_limit_override: number | null;
};

export const useSetOrgAiSummaryOverride = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async ({ orgId, monthly_limit_override }: Payload) => {
      const { data } = await Axios.patch(
        PATCH_URL(String(orgId)).sysopOrgAiSummaryOverride,
        { monthly_limit_override }
      );
      return data;
    },
    {
      onSuccess: (_, { orgId }) => {
        queryClient.invalidateQueries(['sysopOrgAiSummaryQuota', orgId]);
      }
    }
  );
};
